<cap-content-header>
  <cap-title>
    {{ "rechte.SucheTitel" | translate }}
  </cap-title>
</cap-content-header>

<ul [(activeId)]="searchMode" #nav="ngbNav" class="nav-tabs" ngbNav>
  <li [ngbNavItem]="'searchStandard'">
    <a ngbNavLink>{{ "RechteId" | translate }}</a>
    <ng-template id="rechteId" ngbNavContent>
      <cap-recht-suche-rechteid (tabErweitertActive)="saveTabSettings($event)"></cap-recht-suche-rechteid>
    </ng-template>
  </li>

  <li [disabled]="tabErweitertActive" [ngbNavItem]="'searchErweitert'">
    <a ngbNavLink>{{ "Erweitert" | translate }}</a>
    <ng-template id="erweitert" ngbNavContent>
      <cap-recht-suche-erweitert (tabErweitertActive)="saveTabSettings($event)"></cap-recht-suche-erweitert>
    </ng-template>
  </li>

  <li [ngbNavItem]="'searchFachId'">
    <a ngbNavLink>{{ "EREID" | translate }}</a>
    <ng-template id="ereid" ngbNavContent>
      <cap-recht-suche-ereid (tabErweitertActive)="saveTabSettings($event)"></cap-recht-suche-ereid>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
